export default __webpack_public_path__ + "static/media/mountain-6.49d643e9.png";